import axios from 'axios';
import { useDeal } from './context';
import { ActionHandler } from '@components';
import { UserAvatar } from '../utils/avatar';
import {
  RectangleGroupIcon,
  BuildingOfficeIcon,
  BuildingOffice2Icon
} from '@heroicons/react/24/outline';

function Item({
  id,
  taskItemId,
  label,
  subtitle,
  targetType,
  blob_key,
  initials,
  avatar_classes,
  icon,
  selected,
  onClickSuccess = () => {}
}) {
  const { actions = {} } = useDeal();
  const Icon = icon;
  const avatarWidth = 'w-[30px] h-[30px]';

  return (
    <ActionHandler
      onClick={() => {
        actions.updateTaskItem(
          taskItemId,
          { target_type: targetType, target_id: id },
          'La démarche a été mise à jour.'
        );
        onClickSuccess();
      }}
    >
      <div
        className={`flex items-center space-x-2 text-xs mx-1.5 px-1.5 py-1 rounded-lg ${selected ? 'bg-slate-100' : ' hover:bg-slate-50'}`}
      >
        <div>
          {icon && (
            <span
              className={`${avatarWidth} rounded-full bg-amber-100 flex items-center justify-center text-amber-600`}
            >
              <Icon className="w-4 h-4" />
            </span>
          )}
          {(blob_key || initials || avatar_classes) && (
            <UserAvatar width={avatarWidth} user={{ blob_key, initials, avatar_classes }} />
          )}
        </div>
        <div className="flex flex-col">
          <div className="font-hmedium">{label}</div>
          <div className="text-slate-500 text-[11px]">{subtitle}</div>
        </div>
      </div>
    </ActionHandler>
  );
}

function Group({
  label,
  items = [],
  targetType,
  selectedTargetType,
  selectedTargetId,
  taskItemId,
  onClickSuccess
}) {
  return (
    <div className="flex flex-col pb-2">
      <h3 className="py-1 px-3 bg-slate-50 border-t border-b border-slate-200 text-xs font-hmedium">
        {label}
      </h3>
      <div className="flex flex-col pt-1">
        {items.map((item, index) => {
          return (
            <Item
              key={`${index}-${item.id}`}
              id={item.id}
              taskItemId={taskItemId}
              label={item.label}
              subtitle={item.subtitle}
              targetType={targetType}
              onClickSuccess={onClickSuccess}
              {...item}
              selected={
                targetType === selectedTargetType && Number(selectedTargetId) === Number(item.id)
              }
            />
          );
        })}
      </div>
    </div>
  );
}

export function DealObjects({ taskItemId, selectedTargetType, selectedTargetId, onClickSuccess }) {
  const {
    dealObjects: {
      DealMember: members = [],
      Coop: coops = [],
      DealProperty: properties = [],
      Subdivision: subdivisions = []
    } = {}
  } = useDeal();

  const defaultArgs = { onClickSuccess, taskItemId, selectedTargetType, selectedTargetId };

  return (
    <div>
      {members.length >= 1 && (
        <Group label="Intervenants" items={members} targetType="DealMember" {...defaultArgs} />
      )}
      {coops.length >= 1 && (
        <Group
          label="Copropriété"
          items={coops.map(c => ({ ...c, icon: BuildingOffice2Icon }))}
          targetType="Coop"
          {...defaultArgs}
        />
      )}
      {properties.length >= 1 && (
        <Group
          label="Biens"
          items={properties.map(p => ({ ...p, icon: BuildingOfficeIcon }))}
          targetType="DealProperty"
          {...defaultArgs}
        />
      )}
      {subdivisions.length >= 1 && (
        <Group
          label="Lotissements"
          items={subdivisions.map(s => ({ ...s, icon: RectangleGroupIcon }))}
          targetType="Subdivision"
          {...defaultArgs}
        />
      )}
    </div>
  );
}
